import {DiffStats as DiffStatsComponent} from '@github-ui/diffs/DiffStats'
import type {DiffStats} from './comment-action-types'

type CommentActionFileStatsProps = {
  filePath: string | undefined
  diffStats: DiffStats
}

export const CommentActionFileStats = ({filePath, diffStats}: CommentActionFileStatsProps) => {
  return (
    <div className="d-flex flex-items-center gap-2 d-flex flex-row flex-items-center px-2 py-1 bgColor-muted rounded-top-2 border-bottom">
      <span className="color-fg-muted text-small d-flex flex-items-center flex-1 min-width-0 mr-2 ml-1 f6 text-semibold">
        {filePath}
      </span>
      <DiffStatsComponent
        linesAdded={diffStats.linesAdded}
        linesDeleted={diffStats.linesDeleted}
        linesChanged={diffStats.linesChanged}
        hideSquares
      />
    </div>
  )
}
